import { render, staticRenderFns } from "./InfoList.vue?vue&type=template&id=9dc78ca4&"
import script from "./InfoList.vue?vue&type=script&lang=js&"
export * from "./InfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports